<template>
  <div class="md-content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <h1>Shortcuts v2</h1>

        <md-button href="/shortcuts/v2/create">
          Create shortcut
        </md-button>

        <div class="filtersLine">
          <shortcut-group-selector
            no-title
            @groupListChanged="updateGroupFilter"
          />
        </div>

        <md-progress-bar
          v-if="isLoading"
          md-mode="query"
        />
        <v-client-table
          v-else
          ref="table"
          :data="shortcuts"
          :columns="table.columns"
          :options="table.options"
          class="shortcut-table"
        >
          <template #enabled="props">
            {{ props.row.enabled ? 'true' : 'false' }}
          </template>

          <template #title="props">
            {{ props.row.shortcut.title.en }}
          </template>

          <template #slug="props">
            <a
              :href="'/shortcuts/v2/edit/' + props.row.shortcut.id"
              target="_blank"
              rel="noreferrer"
            >
              {{ props.row.shortcut.slug }}
            </a>
          </template>
        </v-client-table>
      </div>
    </div>
  </div>
</template>
<script>
import {Event} from "vue-tables-2-premium";
import ShortcutGroupSelector from "../../components/Forms/shorcut/ShortcutGroupSelector";

export default {
  name: "ShortcutsTableV2",
  components: { ShortcutGroupSelector },
  data() {
    return {
      shortcuts: [],

      isLoading: true,
      table: {
        columns: [
          "enabled", "slug", "title",
        ],
        options: {
          perPage: 100,
          filterable: true,
          customFilters: [
            {
              name: "groups",
              callback(row, query) {
                if (query.length === 0) {
                  return true;
                }

                return row.shortcut_group_ids.some(rowId => query.includes(rowId));
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    this.fetchGroups();
  },
  methods: {
    fetchGroups () {
      this.$http.get("/v1/admin/system/shortcut/list")
        .then(res => {
          this.shortcuts = res.data.shortcuts;
          this.isLoading = false;
        }).catch(err => {
        console.error(err);
        this.$notify({
          group: "foo",
          title: "Couldn't load shortcuts",
        });
      });
    },
    updateGroupFilter(value) {
      Event.$emit("vue-tables.filter::groups", value);
    },
  }
};
</script>
<style scoped>

</style>
